export default function SafetySection() {
  return (
    <section id="bezpieczenstwo" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-secondary-100 flex items-center justify-center mx-auto mb-4">
            <i className="ri-shield-check-line text-secondary-500 text-2xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Czy Kakobuy jest bezpieczny?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Twoje bezpieczeństwo jest najważniejsze. Oto najważniejsze informacje o bezpieczeństwie zakupów przez <strong>Kakobuy Spreadsheet</strong>.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {[
            {
              icon: 'ri-lock-line',
              title: 'Dane użytkownika',
              desc: 'Kakobuy chroni Twoje dane osobowe zgodnie z najwyższymi standardami bezpieczeństwa.',
            },
            {
              icon: 'ri-image-line',
              title: 'Zdjęcia QC',
              desc: 'Otrzymujesz zdjęcia kontroli jakości przed wysyłką, aby upewnić się, że produkt spełnia oczekiwania.',
            },
            {
              icon: 'ri-user-star-line',
              title: 'Sprawdzeni sprzedawcy',
              desc: 'Kakobuy współpracuje tylko ze zweryfikowanymi sprzedawcami o udokumentowanej historii.',
            },
            {
              icon: 'ri-bank-card-line',
              title: 'Bezpieczne płatności',
              desc: 'Wszystkie transakcje są szyfrowane i chronione. Dostępnych jest wiele metod płatności.',
            },
            {
              icon: 'ri-truck-line',
              title: 'Dostawa do Polski',
              desc: 'Kakobuy wysyła paczki do Polski z pełnym śledzeniem przesyłki i ubezpieczeniem.',
            },
            {
              icon: 'ri-error-warning-line',
              title: 'Minimalizacja ryzyka',
              desc: 'Poznaj sprawdzone sposoby na unikanie ryzyka podczas zakupów przez chińskich agentów.',
            },
          ].map((item) => (
            <div
              key={item.title}
              className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-secondary-200 transition-all duration-300"
            >
              <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center mb-3">
                <i className={`${item.icon} text-secondary-500 text-lg`}></i>
              </div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-1.5">{item.title}</h4>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <div className="mt-8 p-4 md:p-5 rounded-xl bg-accent-50 border border-accent-200/60">
          <div className="flex items-start gap-3">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-accent-600 text-sm"></i>
            </div>
            <p className="text-xs md:text-sm text-foreground-700 leading-relaxed">
              <strong>Disclaimer:</strong> Ta strona jest niezależnym przewodnikiem informacyjnym i nie jest oficjalnym przedstawicielem Kakobuy. Wszystkie linki prowadzą do zewnętrznych stron. Zawsze sprawdzaj aktualne warunki i regulaminy przed dokonaniem zakupu.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}